/**
 * AvisoIndexacao — estado da espera pela vetorização do contexto, junto ao
 * botão que inicia a execução. Par de `useIniciarAguardandoIndexacao`.
 */
import { Loader2 } from 'lucide-react';
import { C } from '@/theme/palette';
import { duracaoLegivel } from '@/api/aguardarIndexacao';

export function AvisoIndexacao({ estado, onTentarDeNovo }) {
  if (!estado || estado.fase === 'ocioso') return null;
  const n = Number(estado.pendentes ?? 0).toLocaleString('pt-BR');
  const itens = estado.pendentes === 1 ? 'item' : 'itens';

  if (estado.fase === 'indexando') {
    return (
      <div role="status" aria-live="polite"
        style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 12, color: C.neutralDim, maxWidth: 360 }}>
        <Loader2 size={12} aria-hidden="true" className="animate-spin" style={{ color: C.cyber, flexShrink: 0 }} />
        <span>
          Indexando o contexto ({n} {itens})… a execução começa sozinha assim que terminar.
        </span>
      </div>
    );
  }

  return (
    <div role="alert" style={{ fontSize: 12, color: C.warn, maxWidth: 360 }}>
      A indexação do contexto ainda não terminou depois de {duracaoLegivel(estado.limiteMs ?? 120000)} ({n} {itens} pendentes).
      Tente de novo em instantes; se continuar, confira a tela Auditoria de Contexto.
      {onTentarDeNovo && (
        <button type="button" onClick={onTentarDeNovo}
          style={{ display: 'block', marginTop: 4, background: 'transparent', border: 'none', padding: 0,
            color: C.cyber, fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>
          Tentar de novo
        </button>
      )}
    </div>
  );
}

export default AvisoIndexacao;
